import { createSelector } from "reselect";

const getInfoBanner = state => state.infoBanner;

export const getShowBagBanner = createSelector(
  getInfoBanner,
  ({ showBagBanner }) => showBagBanner
);

export const getBannerType = createSelector(
  getInfoBanner,
  ({ bannerType }) => bannerType
);
